import { JwtService } from './../../services/utilities/jwt-service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, of, tap } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { login, logout, setPermissions } from './auth.actions';
import { User } from '../../interfaces/user-interfaces';
import { Permission } from '../../enums/permissions.enum';
import { Store } from '@ngrx/store';

@Injectable()
export class AuthEffects {
  constructor(private actions$: Actions, private authService: AuthService, private store: Store) {}

  loadPermissionsAfterLogin$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(login), // Listen for the login action
        switchMap((value: { token: string; user: User | null }) => {
          let permissions: Permission[] = JwtService.extractTokenPermissions(value.token);
          this.store.dispatch(setPermissions({ permissions }));
          return of(null);
        })
      ),
    { dispatch: false }
  );

  persistAuthState$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(login, logout),
        tap((action) => {
          if (action.type === login.type) {
            // ✅ Store user data when logging in
            localStorage.setItem('auth', JSON.stringify({ token: action.token, user: action.user }));
          } else {
            // ✅ Clear auth state when logging out
            localStorage.removeItem('auth');
          }
        })
      ),
    { dispatch: false } // ✅ No need to return an action
  );
}
